import { summarize } from './stats';

export type PriceLevel = 'low' | 'typical' | 'high';

export interface TypicalRange {
  typicalLow: number;
  typicalHigh: number;
}

/**
 * Situação histórica do preço na MESMA rota. Movimento (queda/alta) é outra coisa: ver pctChange.
 * Preço igual às bordas da faixa conta como típico.
 */
export function classifyPrice(price: number, range: TypicalRange): PriceLevel {
  if (price < range.typicalLow) return 'low';
  if (price > range.typicalHigh) return 'high';
  return 'typical';
}

/**
 * Faixa típica: usa a da fonte quando existe (Google Flights) e, sem ela, o intervalo interquartil
 * do histórico próprio. Retorna null sem dado suficiente (menos de 5 pontos).
 */
export function typicalRange(
  history: readonly number[],
  fromProvider?: TypicalRange | null,
): TypicalRange | null {
  if (fromProvider && fromProvider.typicalLow > 0 && fromProvider.typicalHigh >= fromProvider.typicalLow) {
    return {
      typicalLow: Math.round(fromProvider.typicalLow),
      typicalHigh: Math.round(fromProvider.typicalHigh),
    };
  }
  if (history.length < 5) return null;
  const s = summarize(history);
  return s ? { typicalLow: s.p25, typicalHigh: s.p75 } : null;
}

/**
 * % abaixo do preço típico (centro da faixa), para "11% abaixo do típico".
 * null quando o preço não está na zona baixa ou a diferença arredonda para zero.
 */
export function belowTypicalPct(price: number, range: TypicalRange): number | null {
  if (price >= range.typicalLow) return null;
  const mid = (range.typicalLow + range.typicalHigh) / 2;
  const pct = Math.round(((mid - price) / mid) * 100);
  return pct > 0 ? pct : null;
}
